<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div style="margin-top: 0;overflow: hidden">
        <div style="float:left;margin-left:15%;margin-top:1%;width: 15%;overflow: hidden"
             :style="{'height':autoHeight-65+'px'}">
            <div style="text-align: center;height: 54px;font-size: 20px;background: #f4f6f7;color: #999;line-height: 54px;font-size: 20px;text-align: center;border-bottom: 1px">
                {{$vuetify.lang.t('$vuetify.API.title_')}}
            </div>
            <div style="margin-top: 0 ;overflow: hidden">
                <v-divider></v-divider>
                <v-list flat>
                    <v-list-item
                            v-for="item in items1"
                            :key="item.text"
                            @click="judeDiv = item.text"
                    >
                        <v-list-item-content>
                            <v-list-item-title v-text="item.text"></v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-list>
                    <v-list-group
                            v-for="item in items"
                            :key="item.title"
                            v-model="item.active"
                    >
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title v-text="item.title"></v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <v-divider></v-divider>

                        <v-list-item
                                v-for="subItem in item.items"
                                :key="subItem.title"
                                @click="judeDiv = subItem.title"
                        >
                            <v-list-item-content>
                                <v-list-item-title v-text="subItem.title"></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>
                </v-list>
            </div>

        </div>
        <div style="float: right;margin-right:5%;width: 65%; overflow: hidden">
            <div v-if="judeDiv== '概述'||judeDiv=='Summary'" style="width: 95%;margin-left:5%;margin-top: 2%;overflow: hidden">
                <div style="font-size: 26px ;width:100%;height:60px;line-height: 60px;color: #333;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.title')}}
                </div>
                <div style="font-size: 10px;color: #999">{{$vuetify.lang.t('$vuetify.API.latestUpdateTime')}}
                </div>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:20px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.title')}}
                </div>
                <p>
                    {{$vuetify.lang.t('$vuetify.API.introduction')}}
                </p>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.interfaceList')}}
                </div>
                <v-divider></v-divider>
                <v-simple-table style="font-family: 微软雅黑">
                    <thead>
                    <tr>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in apiList" :key="item.name">
                        <td style="font-family: 微软雅黑">{{ item.name }}</td>
                    </tr>
                    </tbody>
                </v-simple-table>
                <v-divider></v-divider>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.returnRule')}}
                </div>
                <pre style="font-family: 微软雅黑">{{$vuetify.lang.t('$vuetify.API.returnSample')}}</pre>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.returnIllustrateList')}}
                </div>
                <v-data-table
                        :headers="returnValueDescriptionHeaders"
                        :items="returnValueDescriptionList"
                        hide-default-footer
                >
                    <!--<template slot="items" slot-scope="props">
                        <tr>
                            <td>{{props.item.statusCodeShow}}</td>
                            <td>{{props.item.statusShow}}</td>
                            <td>{{props.item.errorShow}}</td>
                        </tr>
                    </template>-->
                </v-data-table>
                <div style="margin-top:30px;overflow: hidden">
                    <!--  <v-footer padless>
                          <v-col
                                  class="text-center"
                                  cols="12"
                          >
                              {{ new Date().getFullYear() }} — <strong>API接口说明</strong>
                          </v-col>
                      </v-footer>-->
                </div>
            </div>
            <div v-if="judeDiv =='验证Key'||judeDiv =='Verify Key'"  style="width: 95%;margin-left:5%;margin-top:2%;overflow: hidden">
                <div style="font-size: 26px ;width:100%;height:60px;line-height: 60px;color: #333;overflow: hidden">
                    {{this.judeDiv}}
                </div>
                <div style="font-size: 10px;color: #999">{{$vuetify.lang.t('$vuetify.API.latestUpdateTime')}}</div>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:10px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.summary')}}
                </div>
                <p>
                    {{$vuetify.lang.t('$vuetify.API.summary1')}}</p>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.requestURL')}}
                </div>
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{$vuetify.lang.t('$vuetify.API.requestMethod')}}：GET<br><br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;URL：http://202.111.178.10:34710/searchapi/auth
                </p>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.requestField')}}
                </div>
                <v-data-table
                        :headers="KeyrequestParamHeaders"
                        :items="KeyrequestParamList"
                        hide-default-footer
                ></v-data-table>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.responseField')}}
                </div>
                <v-data-table
                        :headers="KeyresponseParamHeaders"
                        :items="KeyresponseParamList"
                        hide-default-footer
                ></v-data-table>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.returnResultExample')}}
                </div>
                <pre style="font-family: 微软雅黑">
{
    "data": {
        "token": "eyJhbGciOiJIUzUxMiJ9.eyJyYW5kb21LZXkiOiJnb2hlZjciLC
                  JzdWIiOiIxMzAxMjM0NTY3OCIsImV4cCI6MTU2MDc1OTE1OCwia
                  WF0IjoxNTYwMTU0MzU4fQ.fs4O8OiyGoQHs3_YnzH8xKTik8gBX
                  T76CNhBFTa0ALd_IImF5DNl5wP_WJIlMw9w3JQ-XsfDWY_5TAnF
                  CxycUg"
    },
    "message": "success",
    "status": 200
}

                </pre>
                <div style="margin-top:30px;overflow: hidden">
                    <!--<v-footer padless>
                        <v-col
                                class="text-center"
                                cols="12"
                        >
                            {{ new Date().getFullYear() }} — <strong>API接口说明</strong>
                        </v-col>
                    </v-footer>-->
                </div>
            </div>
            <div v-if="judeDiv =='标准数据缩略信息查询'||judeDiv =='Standard data abbreviation information query'" style="width: 95%;margin-left:5%;margin-top:2%;overflow: hidden">
                <div style="font-size: 26px ;width:100%;height:60px;line-height: 60px;color: #333;overflow: hidden">
                    {{this.judeDiv}}
                </div>
                <div style="font-size: 10px;color: #999">{{$vuetify.lang.t('$vuetify.API.latestUpdateTime')}}</div>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:10px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.summary')}}
                </div>
                <p>{{$vuetify.lang.t('$vuetify.API.summary2')}}</p>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.requestURL')}}
                </div>
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{$vuetify.lang.t('$vuetify.API.requestMethod')}}：POST<br><br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;URL：http://202.111.178.10:34710/searchapi/metadataQuery/getProductInfoList
                </p>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.requestField')}}
                </div>
                <v-data-table
                        :headers="productInforequestParamHeaders"
                        :items="productInforequestParamList"
                        items-per-page="100"
                        hide-default-footer
                ></v-data-table>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.requestFieldContinued')}}
                </div>
                <v-data-table
                        :headers="productInforequestParamHeaders1"
                        :items="productInforequestParamList1"
                        hide-default-footer

                >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="item in items" :key="item.satelliteId">
                            <td>{{item.productType}}</td>
                            <td>{{item.productBand}}</td>
                            <td>
                                <pre style="font-family: 微软雅黑">{{item.imageGsd}}</pre>
                            </td>
                            <td>
                                <pre style="font-family: 微软雅黑">{{item.satelliteId}}</pre>
                            </td>
                        </tr>
                        </tbody>
                    </template>
                </v-data-table>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.responseField')}}
                </div>
                <v-data-table
                        :headers="productInforesponseParamHeaders"
                        :items="productInforesponseParamList"
                        items-per-page="100"
                        hide-default-footer
                >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="item in items" :key="item.productInforesponsName">
                            <td>{{item.productInforesponsNum}}</td>
                            <td>{{item.productInforesponsName}}</td>
                            <td>{{item.productInforesponsDes}}</td>
                            <td>{{item.productInforesponsType}}</td>
                            <td>{{item.productInforesponsRemark}}</td>
                        </tr>
                        </tbody>
                    </template>
                </v-data-table>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.returnResultExample')}}
                </div>
                <pre style="font-family: 微软雅黑">
{
    "data": {
        "currentPage": 1,
        "order": "asc",
        "pagesize": 20,
        "records": [
            {
                "bandAmount": 6,
                "bandString": "B,G,R,RE,NIR,PAN",
                "centerLatitude": 31.298283,
                "centerLongitude": 114.516233,
                "cloudPercent": 0,
                "id": 3377612,
                "imageGeo": "{\"type\":\"Polygon\",\"coordinates\":[[[114.473433,31.356968],
                 [114.583261,31.337303],[114.558979,31.239602],[114.449262,31.259258],
                 [114.473433,31.356968]]]}",
                "imageGsd": 0.92,
                "imagingTime": "2019-05-22 11:00:12",
                "productBand": "PMS",
                "productId": "JL107B_PMS1
                              _20190522110004_200013679_101_0006_001_L1",
                "productQuality": "A",
                "productType": 1,
                "rollSatelliteAngle": 2.21,
                "satelliteId": "JL107B",
                "sensor": "PMS1",
                "solarElevation": 69.3004,
                "thumbnail": "/thumbnail/JL107B_PMS1
                              _20190522110004_200013679_101_0006_001_L1_MSS.jpg"
            },
            {
                "bandAmount": 5,
                "bandString": "B-G-R-RE-NIR",
                "centerLatitude": 31.2966,
                "centerLongitude": 114.525,
                "cloudPercent": 0,
                "id": 1769552,
                "imageGeo": "{\"type\":\"Polygon\",\"coordinates\":[[[114.591,31.336],
                 [114.483,31.3557],[114.458,31.2572],[114.566,31.2375],
                 [114.591,31.336]]]}",
                "imageGsd": 3.68,
                "imagingTime": "2019-01-23 12:34:42",
                "productBand": "PMS",
                "productId": "JL105B_PMS1
                              _20190123123441_200010916_102_0001_001_L1_MSS",
                "productQuality": "A",
                "productType": 1,
                "rollSatelliteAngle": 0.97,
                "satelliteId": "JL105B",
                "sensor": "PMS1",
                "solarElevation": 39.1381,
                "thumbnail": "/thumbnail/JL105B_PMS1
                              _20190123123441_200010916_102_0001_001_L1_MSS.jpg"
            },
            {
                "bandAmount": 1,
                "bandString": "PAN",
                "centerLatitude": 31.2962,
                "centerLongitude": 114.525,
                "cloudPercent": 0,
                "id": 1769568,
                "imageGeo": "{\"type\":\"Polygon\",\"coordinates\":[[[114.591,31.336],
                 [114.483,31.3557],[114.458,31.2563],[114.566,31.2366],
                 [114.591,31.336]]]}",
                "imageGsd": 0.92,
                "imagingTime": "2019-01-23 12:34:42",
                "productBand": "PMS",
                "productId": "JL105B_PMS1
                              _20190123123441_200010916_102_0001_001_L1_PAN",
                "productQuality": "A",
                "productType": 1,
                "rollSatelliteAngle": 0.97,
                "satelliteId": "JL105B",
                "sensor": "PMS1",
                "solarElevation": 39.139,
                "thumbnail": "/thumbnail/JL105B_PMS1
                              _20190123123441_200010916_102_0001_001_L1_PAN.jpg"
            },
            {
                "bandAmount": 1,
                "bandString": "PAN",
                "centerLatitude": 31.271,
                "centerLongitude": 114.509,
                "cloudPercent": 14,
                "id": 41688,
                "imageGeo": "{\"type\":\"Polygon\",\"coordinates\":[[[114.465,31.3313],
                 [114.577,31.3121],[114.553,31.2107],[114.441,31.23],
                 [114.465,31.3313]]]}",
                "imageGsd": 1.19,
                "imagingTime": "2018-01-30 12:36:03",
                "productBand": "PMS",
                "productId": "JL106B_PMS2
                              _20180130123601_200000865_102_0002_003_L1_PAN",
                "productQuality": "A",
                "productType": 1,
                "rollSatelliteAngle": -9.31,
                "satelliteId": "JL106B",
                "sensor": "PMS2",
                "solarElevation": 41.0003,
                "thumbnail": "/thumbnail/JL106B_PMS2
                              _20180130123601_200000865_102_0002_003_L1_PAN.jpg"
            },
            {
                "bandAmount": 5,
                "bandString": "B-G-R-RE-NIR",
                "centerLatitude": 31.3176,
                "centerLongitude": 114.52,
                "cloudPercent": 14,
                "id": 41664,
                "imageGeo": "{\"type\":\"Polygon\",\"coordinates\":[[[114.465,31.3313],
                 [114.577,31.3121],[114.553,31.2107],[114.441,31.23],
                 [114.465,31.3313]]]}",
                "imageGsd": 1.19,
                "imagingTime": "2018-01-30 12:36:03",
                "productBand": "PMS",
                "productId": "JL106B_PMS2
                              _20180130123601_200000865_102_0002_003_L1_MSS",
                "productQuality": "A",
                "productType": 1,
                "rollSatelliteAngle": -9.31,
                "satelliteId": "JL106B",
                "sensor": "PMS2",
                "solarElevation": 40.9983,
                "thumbnail": "/thumbnail/JL106B_PMS2
                              _20180130123601_200000865_102_0002_003_L1_MSS.jpg"
            },
            {
                "bandAmount": 1,
                "bandString": "PAN",
                "centerLatitude": 31.254844,
                "centerLongitude": 114.58399,
                "cloudPercent": 0,
                "id": 2474430,
                "imageGeo": "{\"type\":\"Polygon\",\"coordinates\":[[[114.530672,31.322368],
                 [114.663313,31.299855],[114.636684,31.187391],[114.504191,31.209898],
                 [114.530672,31.322368]]]}",
                "imageGsd": 1.5,
                "imagingTime": "2016-06-17 11:05:44",
                "productBand": "PMS",
                "productId": "JL101A_PMS
                              _20160617110529_000009877_202_0011_002_L1_PAN",
                "productQuality": "A",
                "productType": 1,
                "rollSatelliteAngle": -18.29,
                "satelliteId": "JL101A",
                "sensor": "PMS",
                "solarElevation": 157.291076,
                "thumbnail": "/thumbnail/JL101A_PMS
                              _20160617110529_000009877_202_0011_002_L1_PAN.jpg"
            },
            {
                "bandAmount": 1,
                "bandString": "PAN",
                "centerLatitude": 31.254844,
                "centerLongitude": 114.58399,
                "cloudPercent": 0,
                "id": 2474402,
                "imageGeo": "{\"type\":\"Polygon\",\"coordinates\":[[[114.530672,31.322368],
                 [114.663313,31.299855],[114.636684,31.187391],[114.504191,31.209898],
                 [114.530672,31.322368]]]}",
                "imageGsd": 1.5,
                "imagingTime": "2016-06-17 11:05:44",
                "productBand": "PMS",
                "productId": "JL101A_PMS
                             _20160617110529_000009877_202_0011_001_L1_PAN",
                "productQuality": "A",
                "productType": 1,
                "rollSatelliteAngle": -18.29,
                "satelliteId": "JL101A",
                "sensor": "PMS",
                "solarElevation": 157.291076,
                "thumbnail": "/thumbnail/JL101A_PMS
                             _20160617110529_000009877_202_0011_001_L1_PAN.jpg"
            }
        ],
        "totalPages": "1",
        "totalSize": "7"
    },
    "message": "success",
    "status": 200
}

                </pre>
                <div style="margin-top:30px;overflow: hidden">
                    <!--<v-footer padless>
                        <v-col
                                class="text-center"
                                cols="12"
                        >
                            {{ new Date().getFullYear() }} — <strong>API接口说明</strong>
                        </v-col>
                    </v-footer>-->
                </div>
            </div>
            <div v-if="judeDiv =='覆盖面积查询接口'||judeDiv =='Coverage area query interface'" style="width: 95%;margin-left:5%;margin-top:2%;overflow: hidden">
                <div style="font-size: 26px ;width:100%;height:60px;line-height: 60px;color: #333;overflow: hidden">
                    {{this.judeDiv}}
                </div>
                <div style="font-size: 10px;color: #999">{{$vuetify.lang.t('$vuetify.API.latestUpdateTime')}}</div>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:10px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.summary')}}
                </div>
                <p>{{$vuetify.lang.t('$vuetify.API.summary3')}}</p>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.requestURL')}}
                </div>
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{$vuetify.lang.t('$vuetify.API.requestMethod')}}：GET/POST<br><br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;URL：http://202.111.178.10:34710/searchapi/sumInfo/getTargetAreaArchiveSumInfo
                </p>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.requestField')}}
                </div>
                <v-data-table
                        :headers="targetArearequestParamHeaders"
                        :items="targetArearequestParamList"
                        items-per-page="100"
                        hide-default-footer
                ></v-data-table>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.requestFieldContinued')}}
                </div>
                <v-data-table
                        :headers="productInforequestParamHeaders1"
                        :items="productInforequestParamList1"
                        hide-default-footer

                >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="item in items" :key="item.satelliteId">
                            <td>{{item.productType}}</td>
                            <td>{{item.productBand}}</td>
                            <td>
                                <pre>{{item.imageGsd}}</pre>
                            </td>
                            <td>
                                <pre>{{item.satelliteId}}</pre>
                            </td>
                        </tr>
                        </tbody>
                    </template>
                </v-data-table>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.responseField')}}
                </div>
                <v-data-table
                        :headers="targetArearesponseParamHeaders"
                        :items="targetArearesponseParamList"
                        items-per-page="100"
                        hide-default-footer
                >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="item in items" :key="item.productInforesponsName">
                            <td>{{item.targetArearesponsNum}}</td>
                            <td>{{item.targetArearesponsName}}</td>
                            <td>{{item.targetArearesponsType}}</td>
                            <td>{{item.productInforesponsType}}</td>
                            <td>{{item.targetArearesponsRemark}}</td>
                        </tr>
                        </tbody>
                    </template>
                </v-data-table>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.returnResultExample')}}
                </div>
                <pre style="font-family: 微软雅黑">
{
    "data": {
        "areaCoverAreaSum": 25977.529438381323,
        "areaCoverGeo": "{\"type\":\"Polygon\",\"coordinates\":
         [[[114.585241929195,31.3131059104804],[114.663313,31.299855],
         [114.636684,31.187391],[114.504191,31.209898],
         [114.506275579717,31.2187516188523],[114.441,31.23],[114.465,31.3313],
         [114.466998625498,31.3309573784861],[114.473433,31.356968],
         [114.482891966134,31.3552743465689],[114.483,31.3557],
         [114.591,31.336],[114.585241929195,31.3131059104804]]]}",
        "areaCoverPercent": 1,
        "areaSceneSum": "15",
        "areaShootAreaSum": 60862.1047366295,
        "productCoverAreaSum": 268.4217455233133,
        "productSceneSum": "7",
        "productShootAreaSum": 931.2593773611
    },
    "message": "success",
    "status": 200
}

                </pre>
                <div style="margin-top:30px;overflow: hidden">
                    <!--<v-footer padless>
                        <v-col
                                class="text-center"
                                cols="12"
                        >
                            {{ new Date().getFullYear() }} — <strong>API接口说明</strong>
                        </v-col>
                    </v-footer>-->
                </div>
            </div>
            <div v-if="judeDiv =='存档数据信息统计接口'||judeDiv =='Archive data information statistics interface'" style="width:95%;margin-left:5%;margin-top:2%;overflow: hidden">
                <div style="font-size: 26px ;width:100%;height:60px;line-height: 60px;color: #333;overflow: hidden">
                    {{this.judeDiv}}
                </div>
                <div style="font-size: 10px;color: #999">{{$vuetify.lang.t('$vuetify.API.latestUpdateTime')}}</div>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:10px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.summary')}}
                </div>
                <p>{{$vuetify.lang.t('$vuetify.API.summary4')}}</p>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.requestURL')}}
                </div>
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{$vuetify.lang.t('$vuetify.API.requestMethod')}}：GET/POST<br><br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;URL：http://202.111.178.10:34710/searchapi/sumInfo/getArchiveSumInfo
                </p>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.requestField')}}
                </div>
                <v-data-table
                        :headers="ArchiverequestParamHeaders"
                        :items="ArchiverequestParamList"
                        hide-default-footer
                ></v-data-table>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.responseField')}}
                </div>
                <v-data-table
                        :headers="ArchiveresponseParamHeaders"
                        :items="ArchiveresponseParamList"
                        hide-default-footer
                ></v-data-table>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.returnResultExample')}}
                </div>
                <pre style="font-family: 微软雅黑">
{
    "data": {
        "areaCoverAreaSum": 25977.529438381323,
        "areaCoverGeo": "{\"type\":\"Polygon\",\"coordinates\":
                    [[[114.585241929195,31.3131059104804],[114.663313,31.299855],
                    [114.636684,31.187391],[114.58291347723,31.1965251667559],
                    [114.58,31.1854],[114.543995095677,31.1922653419259],
                    [114.543,31.188],[114.54265490469,31.1880619893428],
                    [114.542,31.1853],[114.434,31.2046],[114.457139534884,31.2981222868222],
                    [114.465,31.3313],[114.466998625498,31.3309573784861],
                    [114.473433,31.356968],[114.482891966134,31.3552743465689],
                    [114.483,31.3557],[114.591,31.336],[114.585241929195,31.3131059104804]]]}",
        "areaCoverPercent": 1,
        "areaSceneSum": "19",
        "areaShootAreaSum": 61357.4397138957,
        "productCoverAreaSum": 299.7592048145177,
        "productSceneSum": "11",
        "productShootAreaSum": 1426.5943546273
    },
    "message": "success",
    "status": 200
}


                </pre>
                <div style="margin-top:30px;overflow: hidden">
                    <!--<v-footer padless>
                        <v-col
                                class="text-center"
                                cols="12"
                        >
                            {{ new Date().getFullYear() }} — <strong>API接口说明</strong>
                        </v-col>
                    </v-footer>-->
                </div>
            </div>
            <div v-if="judeDiv =='卫星过境查询接口'||judeDiv == 'Satellite transit query interface'" style="width: 95%;margin-left:5%;margin-top:2%;overflow: hidden">
                <div style="font-size: 26px ;width:100%;height:60px;line-height: 60px;color: #333;overflow: hidden">
                    {{this.judeDiv}}
                </div>
                <div style="font-size: 10px;color: #999">{{$vuetify.lang.t('$vuetify.API.latestUpdateTime')}}</div>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:10px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.summary')}}
                </div>
                <p>{{$vuetify.lang.t('$vuetify.API.summary5')}}</p>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.requestURL')}}
                </div>
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{$vuetify.lang.t('$vuetify.API.requestMethod')}}：GET<br><br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;URL：http://10.10.108.31:8022/rm-0.0.1-SNAPSHOT/transitTimeQuery
                </p>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.requestField')}}
                </div>
                <v-data-table
                        :headers="transitrequestParamHeaders"
                        :items="transitrequestParamList"
                        hide-default-footer
                ></v-data-table>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.responseField')}}
                </div>
                <v-data-table
                        :headers="transitresponseParamHeaders"
                        :items="transitresponseParamList"
                        hide-default-footer
                ></v-data-table>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.returnResultExample')}}
                </div>
                <pre style="font-family: 微软雅黑">
{
    "status": 200,
    "message": "success",
    "data": {
        "size": 2,
        "items": [
            {
                "sideAngle": -45,
                "startAvailableTime": "2019-04-28 05:46:18",
                "endAvailableTime": "2019-04-28 05:46:18",
                "solarEA": -54.9479686872699
            },
            {
                "sideAngle": 30.963795216269027,
                "startAvailableTime": "2019-04-28 17:51:44",
                "endAvailableTime": "2019-04-28 17:51:44",
                "solarEA": 71.13126097219315
            }
        ]
    }
}
}

                </pre>
                <div style="margin-top:30px;overflow: hidden">
                    <!--<v-footer padless>
                        <v-col
                                class="text-center"
                                cols="12"
                        >
                            {{ new Date().getFullYear() }} — <strong>API接口说明</strong>
                        </v-col>
                    </v-footer>-->
                </div>
            </div>
            <div v-if="judeDiv =='编程摄影提交接口'||judeDiv == 'Programming photography submission interface'" style="width: 95%;margin-left:5%;margin-top:2%;overflow: hidden">
                <div style="font-size: 26px ;width:100%;height:60px;line-height: 60px;color: #333;overflow: hidden">
                    {{this.judeDiv}}
                </div>
                <div style="font-size: 10px;color: #999">{{$vuetify.lang.t('$vuetify.API.latestUpdateTime')}}</div>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:10px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.summary')}}
                </div>
                <p>{{$vuetify.lang.t('$vuetify.API.summary6')}}</p>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.requestURL')}}
                </div>
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{$vuetify.lang.t('$vuetify.API.requestMethod')}}：POST<br><br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;URL：http://10.10.108.31:8022/rm-0.0.1-SNAPSHOT/getProgrammingRequirement
                </p>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.requestField')}}
                </div>
                <v-data-table
                        :headers="ProgrammingrequestParamHeaders"
                        :items="ProgrammingrequestParamList"
                        items-per-page="100"
                        hide-default-footer
                ></v-data-table>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.responseField')}}
                </div>
                <v-data-table
                        :headers="ProgrammingresponseParamHeaders"
                        :items="ProgrammingsponseParamList"
                        items-per-page="100"
                        hide-default-footer
                >
                </v-data-table>
                <div style="font-size: 20px;width:100%;height:40px;line-height: 40px;color: #333;margin-top:30px;margin-bottom: 10px;overflow: hidden">
                    {{$vuetify.lang.t('$vuetify.API.returnResultExample')}}
                </div>
                <pre style="font-family: 微软雅黑">
{
    "status": 200,
    "message": "success",
    "data": “requirementId”
}
                </pre>
                <div style="margin-top:30px;overflow: hidden">
                    <!--<v-footer padless>
                        <v-col
                                class="text-center"
                                cols="12"
                        >
                            {{ new Date().getFullYear() }} — <strong>API接口说明</strong>
                        </v-col>
                    </v-footer>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "API",
        data() {
            return {
                judeDiv: this.$vuetify.lang.t('$vuetify.API.judeDiv'),
                productInforequestParamHeaders1: [
                    {text: 'productType', sortable: false, value: ''},
                    {text: 'productBand', sortable: false, value: ''},
                    {text: 'imageGsd', sortable: false, value: ''},
                    {text: 'satelliteId', sortable: false, value: ''}
                ],
            }
        },
        watch: {},
        methods: {
            changeColor() {
                var item = document.getElementById('itemTitle')
                item.onclick = function () {
                    item.style = "background:#999999"
                }
            },
            loadData() {
                this.axios.get('http://10.10.90.2:8101/v2/api-docs').then(() => {
                    // console.log(response)
                })
            }

        },
        computed: {
            autoHeight() {
                return this.$store.state.clientHeight
            },
            apiList() {
                const apiList = [                                        //概述接口列表
                    {name: this.$vuetify.lang.t('$vuetify.API.apiList1')},
                    //{name:'标准数据详情查询（暂未开放）'},
                    {name: this.$vuetify.lang.t('$vuetify.API.apiList2')},
                    {name: this.$vuetify.lang.t('$vuetify.API.apiList3')},
                    {name: this.$vuetify.lang.t('$vuetify.API.apiList4')},
                    {name: this.$vuetify.lang.t('$vuetify.API.apiList5')},
                    {name: this.$vuetify.lang.t('$vuetify.API.apiList6')},
                ];
                return apiList
            },
            returnValueDescriptionList() {
                const list = [                  //返回值说明表参数
                    {
                        statusCodeShow: '200',
                        statusShow: this.$vuetify.lang.t('$vuetify.API.returnDescriptionListStatus1'),
                        errorShow: this.$vuetify.lang.t('$vuetify.API.returnDescriptionListStatus00')
                    },
                    {
                        statusCodeShow: '-1',
                        statusShow: this.$vuetify.lang.t('$vuetify.API.returnDescriptionListStatus2'),
                        errorShow: this.$vuetify.lang.t('$vuetify.API.returnDescriptionListStatus00')
                    },
                    {
                        statusCodeShow: '102',
                        statusShow: this.$vuetify.lang.t('$vuetify.API.returnDescriptionListStatus2'),
                        errorShow: this.$vuetify.lang.t('$vuetify.API.returnDescriptionListStatus00')
                    },
                    {
                        statusCodeShow: '103',
                        statusShow: this.$vuetify.lang.t('$vuetify.API.returnDescriptionListStatus4'),
                        errorShow: this.$vuetify.lang.t('$vuetify.API.returnDescriptionListStatus00')
                    },
                    {
                        statusCodeShow: '301',
                        statusShow: this.$vuetify.lang.t('$vuetify.API.returnDescriptionListStatus5'),
                        errorShow: this.$vuetify.lang.t('$vuetify.API.returnDescriptionListStatus00')
                    },
                    {
                        statusCodeShow: '303',
                        statusShow: this.$vuetify.lang.t('$vuetify.API.returnDescriptionListStatus6'),
                        errorShow: this.$vuetify.lang.t('$vuetify.API.returnDescriptionListStatus00')
                    },
                    {
                        statusCodeShow: '304',
                        statusShow: this.$vuetify.lang.t('$vuetify.API.returnDescriptionListStatus7'),
                        errorShow: this.$vuetify.lang.t('$vuetify.API.returnDescriptionListStatus00')
                    },
                    {
                        statusCodeShow: '400',
                        statusShow: this.$vuetify.lang.t('$vuetify.API.returnDescriptionListStatus8'),
                        errorShow: this.$vuetify.lang.t('$vuetify.API.returnDescriptionListStatus81')
                    },
                    {
                        statusCodeShow: '401',
                        statusShow: this.$vuetify.lang.t('$vuetify.API.returnDescriptionListStatus9'),
                        errorShow: this.$vuetify.lang.t('$vuetify.API.returnDescriptionListStatus91')
                    },
                    {
                        statusCodeShow: '700',
                        statusShow: this.$vuetify.lang.t('$vuetify.API.returnDescriptionListStatus10'),
                        errorShow: this.$vuetify.lang.t('$vuetify.API.returnDescriptionListStatus101')
                    },
                ];
                return list;
            },
            items1() {
                const list = [                                  //左侧list栏
                    {text: this.$vuetify.lang.t('$vuetify.API.itemsTitle1')},
                    {text: this.$vuetify.lang.t('$vuetify.API.itemsTitle2')},
                ];
                return list;
            },
            items() {
                const list = [                                  //左侧list栏
                    {
                        title: this.$vuetify.lang.t('$vuetify.API.items11'),
                        //active:true,
                        items: [
                            {title: this.$vuetify.lang.t('$vuetify.API.items12')},
                            //{ title: '标准数据详情查询' },
                            {title: this.$vuetify.lang.t('$vuetify.API.items13')},
                            {title: this.$vuetify.lang.t('$vuetify.API.items14')},
                        ],
                    },
                    // {
                    //     title: this.$vuetify.lang.t('$vuetify.API.items21'),
                    //     //active:true,
                    //     items: [
                    //         {title: this.$vuetify.lang.t('$vuetify.API.items22')},
                    //     ],
                    // },
                    // {
                    //     title: this.$vuetify.lang.t('$vuetify.API.items31'),
                    //     //active:true,
                    //     items: [
                    //         {title: this.$vuetify.lang.t('$vuetify.API.items32')},
                    //     ],
                    // },
                ];
                return list;
            },
            KeyrequestParamHeaders() {
                const list = [
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyrequestParamHeaders1'),
                        sortable: false,
                        value: 'keyparamName'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyrequestParamHeaders2'),
                        sortable: false,
                        value: 'keyparamDes'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyrequestParamHeaders3'),
                        sortable: false,
                        value: 'keyparamType'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyrequestParamHeaders4'),
                        sortable: false,
                        value: 'keyparamBoolean'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyrequestParamHeaders5'),
                        sortable: false,
                        value: 'keyparamRemark'
                    }
                ];
                return list;
            },
            KeyrequestParamList() {
                const list = [
                    {
                        keyparamName: 'account',
                        keyparamDes: this.$vuetify.lang.t('$vuetify.API.KeyrequestParamList1'),
                        keyparamType: 'String',
                        keyparamBoolean: 'TRUE',
                        keyparamRemark: ''
                    },
                    {
                        keyparamName: 'password',
                        keyparamDes: this.$vuetify.lang.t('$vuetify.API.KeyrequestParamList2'),
                        keyparamType: 'String',
                        keyparamBoolean: 'TRUE',
                        keyparamRemark: ''
                    },
                ];
                return list;
            },
            KeyresponseParamHeaders() {
                const list = [
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamHeaders1'),
                        sortable: false,
                        value: 'keyrespParamNum'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamHeaders2'),
                        sortable: false,
                        value: 'keyrespParamName'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamHeaders3'),
                        sortable: false,
                        value: 'keyrespParamDes'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamHeaders4'),
                        sortable: false,
                        value: 'keyrespParamType'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamHeaders5'),
                        sortable: false,
                        value: 'keyrespParamRemark'
                    },
                ];
                return list;
            },
            KeyresponseParamList() {
                const list = [
                    {
                        keyrespParamNum: '1',
                        keyrespParamName: 'status',
                        keyrespParamDes: '',
                        keyrespParamType: '',
                        keyrespParamRemark: ''
                    },
                    {
                        keyrespParamNum: '2',
                        keyrespParamName: 'message',
                        keyrespParamDes: '',
                        keyrespParamType: '',
                        keyrespParamRemark: ''
                    },
                    {
                        keyrespParamNum: '3',
                        keyrespParamName: 'data',
                        keyrespParamDes: '',
                        keyrespParamType: '',
                        keyrespParamRemark: ''
                    },
                    {
                        keyrespParamNum: '3.1',
                        keyrespParamName: 'token',
                        keyrespParamDes: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamList41'),
                        keyrespParamType: 'String',
                        keyrespParamRemark: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamList42')
                    },
                ];
                return list;
            },
            productInforequestParamHeaders() {
                //标准数据缩略信息查询
                const list = [
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.productInforequestParamHeaders1'),
                        sortable: false,
                        value: 'productInfoparamName'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.productInforequestParamHeaders2'),
                        sortable: false,
                        value: 'productInfoparamDes'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.productInforequestParamHeaders3'),
                        sortable: false,
                        value: 'productInfoparamType'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.productInforequestParamHeaders4'),
                        sortable: false,
                        value: 'productInfoparamBoolean'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.productInforequestParamHeaders5'),
                        sortable: false,
                        value: 'productInfoparamRemark'
                    },
                ];
                return list;
            },
            productInforequestParamList() {
                const list = [
                    {
                        productInfoparamName: 'pageSize',
                        productInfoparamDes: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList11'),
                        productInfoparamType: 'int',
                        productInfoparamBoolean: 'TRUE',
                        productInfoparamRemark: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList12')
                    },
                    {
                        productInfoparamName: 'pageNum',
                        productInfoparamDes: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList21'),
                        productInfoparamType: 'int',
                        productInfoparamBoolean: 'TRUE',
                        productInfoparamRemark: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList22')
                    },
                    {
                        productInfoparamName: 'orderByField',
                        productInfoparamDes: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList31'),
                        productInfoparamType: 'String',
                        productInfoparamBoolean: 'FALSE',
                        productInfoparamRemark: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList32')
                    },
                    {
                        productInfoparamName: 'order',
                        productInfoparamDes: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList41'),
                        productInfoparamType: 'String',
                        productInfoparamBoolean: 'FALSE',
                        productInfoparamRemark: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList42')
                    },
                    {
                        productInfoparamName: 'productType',
                        productInfoparamDes: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList51'),
                        productInfoparamType: 'Integer',
                        productInfoparamBoolean: 'FALSE',
                        productInfoparamRemark: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList52')
                    },
                    {
                        productInfoparamName: 'productBand',
                        productInfoparamDes: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList61'),
                        productInfoparamType: 'String',
                        productInfoparamBoolean: 'FALSE',
                        productInfoparamRemark: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList62')
                    },
                    {
                        productInfoparamName: 'imageGsd',
                        productInfoparamDes: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList71'),
                        productInfoparamType: 'numeric',
                        productInfoparamBoolean: 'FALSE',
                        productInfoparamRemark: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList72')
                    },
                    {
                        productInfoparamName: 'cloudPercent',
                        productInfoparamDes: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList81'),
                        productInfoparamType: 'numeric',
                        productInfoparamBoolean: 'FALSE',
                        productInfoparamRemark: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList82')
                    },
                    {
                        productInfoparamName: 'rollSatelliteAngle',
                        productInfoparamDes: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList91'),
                        productInfoparamType: 'numeric',
                        productInfoparamBoolean: 'FALSE',
                        productInfoparamRemark: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList92')
                    },
                    {
                        productInfoparamName: 'imagingTimeStart',
                        productInfoparamDes: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList101'),
                        productInfoparamType: 'String',
                        productInfoparamBoolean: 'FALSE',
                        productInfoparamRemark: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList102')
                    },
                    {
                        productInfoparamName: 'imagingTimeEnd',
                        productInfoparamDes: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList111'),
                        productInfoparamType: 'String',
                        productInfoparamBoolean: 'FALSE',
                        productInfoparamRemark: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList112')
                    },
                    {
                        productInfoparamName: 'productQuality',
                        productInfoparamDes: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList121'),
                        productInfoparamType: 'String',
                        productInfoparamBoolean: 'FALSE',
                        productInfoparamRemark: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList122')
                    },
                    {
                        productInfoparamName: 'geo',
                        productInfoparamDes: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList131'),
                        productInfoparamType: 'String',
                        productInfoparamBoolean: 'FALSE',
                        productInfoparamRemark: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList132')
                    },
                ];
                return list;
            },
            productInforequestParamList1() {
                const list = [
                    {
                        productType: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList1_11'),
                        productBand: 'PMS',
                        imageGsd: '1:<1m\n' +
                            '2:1m-2m\n' +
                            '3:2m-5m',
                        satelliteId: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList1_12')
                    },
                    {
                        productType: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList1_21'),
                        productBand: 'MSS',
                        imageGsd: '1:<1m\n' +
                            '2:1m-2m\n' +
                            '3:2m-5m',
                        satelliteId: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList1_22')
                    },
                    {
                        productType: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList1_31'),
                        productBand: 'MSS',
                        imageGsd: '1:<1m\n' +
                            '2:1m-2m\n' +
                            '3:2m-5m',
                        satelliteId: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList1_32')
                    },
                    {
                        productType: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList1_41'),
                        productBand: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList1_42'),
                        imageGsd: '4:5m-10m\n' +
                            '5:100m-150m\n' +
                            '6:>150m',
                        satelliteId: this.$vuetify.lang.t('$vuetify.API.productInforequestParamList1_43')
                    },
                ];
                return list;
            },
            productInforesponseParamHeaders() {
                const list = [
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamHeaders1'),
                        sortable: false,
                        value: 'productInforesponsNum'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamHeaders2'),
                        sortable: false,
                        value: 'productInforesponsName'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamHeaders3'),
                        sortable: false,
                        value: 'productInforesponsDes'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamHeaders4'),
                        sortable: false,
                        value: 'productInforesponsType'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamHeaders5'),
                        sortable: false,
                        value: 'productInforesponsRemark'
                    },
                ];
                return list;
            },
            productInforesponseParamList() {
                const list = [
                    {
                        productInforesponsNum: '1',
                        productInforesponsName: 'status',
                        productInforesponsDes: '',
                        productInforesponsType: '',
                        productInforesponsRemark: ''
                    },
                    {
                        productInforesponsNum: '2',
                        productInforesponsName: 'message',
                        productInforesponsDes: '',
                        productInforesponsType: '',
                        productInforesponsRemark: ''
                    },
                    {
                        productInforesponsNum: '3',
                        productInforesponsName: 'data',
                        productInforesponsDes: '',
                        productInforesponsType: '',
                        productInforesponsRemark: ''
                    },
                    {
                        productInforesponsNum: '3.1',
                        productInforesponsName: 'records',
                        productInforesponsDes: this.$vuetify.lang.t('$vuetify.API.productInforesponseParamList31'),
                        productInforesponsType: '',
                        productInforesponsRemark: ''
                    },
                    {
                        productInforesponsNum: '3.1.1',
                        productInforesponsName: 'productId',
                        productInforesponsDes: this.$vuetify.lang.t('$vuetify.API.productInforesponseParamList311'),
                        productInforesponsType: 'String',
                        productInforesponsRemark: ''
                    },
                    {
                        productInforesponsNum: '3.1.2',
                        productInforesponsName: 'satelliteId',
                        productInforesponsDes: this.$vuetify.lang.t('$vuetify.API.productInforesponseParamList312'),
                        productInforesponsType: 'String',
                        productInforesponsRemark: ''
                    },
                    {
                        productInforesponsNum: '3.1.3',
                        productInforesponsName: 'imageGsd',
                        productInforesponsDes: this.$vuetify.lang.t('$vuetify.API.productInforesponseParamList313'),
                        productInforesponsType: 'numeric',
                        productInforesponsRemark: ''
                    },
                    {
                        productInforesponsNum: '3.1.4',
                        productInforesponsName: 'imagingTime',
                        productInforesponsDes: this.$vuetify.lang.t('$vuetify.API.productInforesponseParamList314'),
                        productInforesponsType: 'String',
                        productInforesponsRemark: '2019-05-28 10:50:55'
                    },
                    {
                        productInforesponsNum: '3.1.5',
                        productInforesponsName: 'imageGeo',
                        productInforesponsDes: this.$vuetify.lang.t('$vuetify.API.productInforesponseParamList315'),
                        productInforesponsType: 'String',
                        productInforesponsRemark: ''
                    },
                    {
                        productInforesponsNum: '3.1.6',
                        productInforesponsName: 'bandAmount',
                        productInforesponsDes: this.$vuetify.lang.t('$vuetify.API.productInforesponseParamList316'),
                        productInforesponsType: 'int',
                        productInforesponsRemark: ''
                    },
                    {
                        productInforesponsNum: '3.1.7',
                        productInforesponsName: 'bandString',
                        productInforesponsDes: this.$vuetify.lang.t('$vuetify.API.productInforesponseParamList317'),
                        productInforesponsType: 'String',
                        productInforesponsRemark: ''
                    },
                    {
                        productInforesponsNum: '3.1.8',
                        productInforesponsName: 'cloudPercent',
                        productInforesponsDes: this.$vuetify.lang.t('$vuetify.API.productInforesponseParamList318'),
                        productInforesponsType: 'numeric',
                        productInforesponsRemark: ''
                    },
                    {
                        productInforesponsNum: '3.1.9',
                        productInforesponsName: 'rollSatelliteAngle',
                        productInforesponsDes: this.$vuetify.lang.t('$vuetify.API.productInforesponseParamList319'),
                        productInforesponsType: 'numeric',
                        productInforesponsRemark: ''
                    },
                    {
                        productInforesponsNum: '3.1.10',
                        productInforesponsName: 'thumbnail',
                        productInforesponsDes: this.$vuetify.lang.t('$vuetify.API.productInforesponseParamList3110'),
                        productInforesponsType: 'String',
                        productInforesponsRemark: ''
                    },
                    {
                        productInforesponsNum: '3.1.11',
                        productInforesponsName: 'thumb',
                        productInforesponsDes: this.$vuetify.lang.t('$vuetify.API.productInforesponseParamList3111'),
                        productInforesponsType: 'String',
                        productInforesponsRemark: ''
                    },
                    {
                        productInforesponsNum: '3.1.12',
                        productInforesponsName: 'productQuality',
                        productInforesponsDes: this.$vuetify.lang.t('$vuetify.API.productInforesponseParamList3112'),
                        productInforesponsType: 'String',
                        productInforesponsRemark: ''
                    },
                    {
                        productInforesponsNum: '3.1.13',
                        productInforesponsName: 'productType',
                        productInforesponsDes: this.$vuetify.lang.t('$vuetify.API.productInforesponseParamList3113'),
                        productInforesponsType: 'String',
                        productInforesponsRemark: ''
                    },
                    {
                        productInforesponsNum: '3.1.14',
                        productInforesponsName: 'solarElevation',
                        productInforesponsDes: this.$vuetify.lang.t('$vuetify.API.productInforesponseParamList3114'),
                        productInforesponsType: 'String',
                        productInforesponsRemark: ''
                    },
                    {
                        productInforesponsNum: '3.1.15',
                        productInforesponsName: 'centerLongitude',
                        productInforesponsDes: this.$vuetify.lang.t('$vuetify.API.productInforesponseParamList3115'),
                        productInforesponsType: 'numeric',
                        productInforesponsRemark: ''
                    },
                    {
                        productInforesponsNum: '3.1.16',
                        productInforesponsName: 'centerLatitude',
                        productInforesponsDes: this.$vuetify.lang.t('$vuetify.API.productInforesponseParamList3116'),
                        productInforesponsType: 'numeric',
                        productInforesponsRemark: ''
                    },
                    {
                        productInforesponsNum: '3.1.17',
                        productInforesponsName: 'sensor',
                        productInforesponsDes: this.$vuetify.lang.t('$vuetify.API.productInforesponseParamList3117'),
                        productInforesponsType: 'String',
                        productInforesponsRemark: ''
                    },
                    {
                        productInforesponsNum: '3.1.18',
                        productInforesponsName: 'productBand',
                        productInforesponsDes: this.$vuetify.lang.t('$vuetify.API.productInforesponseParamList3118'),
                        productInforesponsType: 'String',
                        productInforesponsRemark: ''
                    },
                    {
                        productInforesponsNum: '3.2',
                        productInforesponsName: 'totalSize',
                        productInforesponsDes: this.$vuetify.lang.t('$vuetify.API.productInforesponseParamList32'),
                        productInforesponsType: 'long',
                        productInforesponsRemark: ''
                    },
                    {
                        productInforesponsNum: '3.3',
                        productInforesponsName: 'totalPages',
                        productInforesponsDes: this.$vuetify.lang.t('$vuetify.API.productInforesponseParamList33'),
                        productInforesponsType: 'long',
                        productInforesponsRemark: ''
                    },
                    {
                        productInforesponsNum: '3.4',
                        productInforesponsName: 'currentPage',
                        productInforesponsDes: this.$vuetify.lang.t('$vuetify.API.productInforesponseParamList34'),
                        productInforesponsType: 'int',
                        productInforesponsRemark: ''
                    },
                    {
                        productInforesponsNum: '3.5',
                        productInforesponsName: 'pageSize',
                        productInforesponsDes: this.$vuetify.lang.t('$vuetify.API.productInforesponseParamList35'),
                        productInforesponsType: 'int',
                        productInforesponsRemark: ''
                    },
                    {
                        productInforesponsNum: '3.6',
                        productInforesponsName: 'order',
                        productInforesponsDes: this.$vuetify.lang.t('$vuetify.API.productInforesponseParamList36'),
                        productInforesponsType: 'String',
                        productInforesponsRemark: ''
                    },
                    {
                        productInforesponsNum: '3.7',
                        productInforesponsName: 'orderByField',
                        productInforesponsDes: this.$vuetify.lang.t('$vuetify.API.productInforesponseParamList37'),
                        productInforesponsType: 'String',
                        productInforesponsRemark: ''
                    },
                ];
                return list;
            },
            targetArearequestParamHeaders() {
                //覆盖面积查询接口
                const list = [
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.productInforequestParamHeaders1'),
                        sortable: false,
                        value: 'targetAreafoparamName'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.productInforequestParamHeaders2'),
                        sortable: false,
                        value: 'targetAreaparamDes'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.productInforequestParamHeaders3'),
                        sortable: false,
                        value: 'targetAreaparamType'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.productInforequestParamHeaders4'),
                        sortable: false,
                        value: 'targetAreaparamBool'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.productInforequestParamHeaders5'),
                        sortable: false,
                        value: 'targetAreaparamRemark'
                    }
                ];
                return list;
            },
            targetArearequestParamList() {
                const list = [
                    {
                        targetAreafoparamName: 'Authorization',
                        targetAreaparamDes: this.$vuetify.lang.t('$vuetify.API.targetArearequestParamList11'),
                        targetAreaparamType: 'String',
                        targetAreaparamBool: 'TRUE',
                        targetAreaparamRemark: this.$vuetify.lang.t('$vuetify.API.targetArearequestParamList12')
                    },
                    {
                        targetAreafoparamName: 'satelliteId',
                        targetAreaparamDes: this.$vuetify.lang.t('$vuetify.API.targetArearequestParamList21'),
                        targetAreaparamType: 'String',
                        targetAreaparamBool: 'FALSE',
                        targetAreaparamRemark: this.$vuetify.lang.t('$vuetify.API.targetArearequestParamList22')
                    },
                    {
                        targetAreafoparamName: 'productType',
                        targetAreaparamDes: this.$vuetify.lang.t('$vuetify.API.targetArearequestParamList31'),
                        targetAreaparamType: 'Integer',
                        targetAreaparamBool: 'FALSE',
                        targetAreaparamRemark: this.$vuetify.lang.t('$vuetify.API.targetArearequestParamList32')
                    },
                    {
                        targetAreafoparamName: 'productBand',
                        targetAreaparamDes: this.$vuetify.lang.t('$vuetify.API.targetArearequestParamList41'),
                        targetAreaparamType: 'String',
                        targetAreaparamBool: 'FALSE',
                        targetAreaparamRemark: this.$vuetify.lang.t('$vuetify.API.targetArearequestParamList42')
                    },
                    {
                        targetAreafoparamName: 'imageGsd',
                        targetAreaparamDes: this.$vuetify.lang.t('$vuetify.API.targetArearequestParamList51'),
                        targetAreaparamType: 'numeric',
                        targetAreaparamBool: 'FALSE',
                        targetAreaparamRemark: this.$vuetify.lang.t('$vuetify.API.targetArearequestParamList52')
                    },
                    {
                        targetAreafoparamName: 'cloudPercent',
                        targetAreaparamDes: this.$vuetify.lang.t('$vuetify.API.targetArearequestParamList61'),
                        targetAreaparamType: 'numeric',
                        targetAreaparamBool: 'FALSE',
                        targetAreaparamRemark: this.$vuetify.lang.t('$vuetify.API.targetArearequestParamList62')
                    },
                    {
                        targetAreafoparamName: 'rollSatelliteAngle',
                        targetAreaparamDes: this.$vuetify.lang.t('$vuetify.API.targetArearequestParamList71'),
                        targetAreaparamType: 'numeric',
                        targetAreaparamBool: 'FALSE',
                        targetAreaparamRemark: this.$vuetify.lang.t('$vuetify.API.targetArearequestParamList72')
                    },
                    {
                        targetAreafoparamName: 'imagingTimeStart',
                        targetAreaparamDes: this.$vuetify.lang.t('$vuetify.API.targetArearequestParamList81'),
                        targetAreaparamType: 'String',
                        targetAreaparamBool: 'FALSE',
                        targetAreaparamRemark: this.$vuetify.lang.t('$vuetify.API.targetArearequestParamList82')
                    },
                    {
                        targetAreafoparamName: 'imagingTimeEnd',
                        targetAreaparamDes: this.$vuetify.lang.t('$vuetify.API.targetArearequestParamList91'),
                        targetAreaparamType: 'String',
                        targetAreaparamBool: 'FALSE',
                        targetAreaparamRemark: this.$vuetify.lang.t('$vuetify.API.targetArearequestParamList92')
                    },
                    {
                        targetAreafoparamName: 'productQuality',
                        targetAreaparamDes: this.$vuetify.lang.t('$vuetify.API.targetArearequestParamList101'),
                        targetAreaparamType: 'String',
                        targetAreaparamBool: 'FALSE',
                        targetAreaparamRemark: this.$vuetify.lang.t('$vuetify.API.targetArearequestParamList102')
                    },
                    {
                        targetAreafoparamName: 'geo',
                        targetAreaparamDes: this.$vuetify.lang.t('$vuetify.API.targetArearequestParamList111'),
                        targetAreaparamType: 'String',
                        targetAreaparamBool: 'FALSE',
                        targetAreaparamRemark: this.$vuetify.lang.t('$vuetify.API.targetArearequestParamList112')
                    },
                ];
                return list;
            },
            targetArearesponseParamHeaders() {
                const list = [
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyrequestParamHeaders1'),
                        sortable: false,
                        value: 'targetArearesponsNum'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyrequestParamHeaders2'),
                        sortable: false,
                        value: 'targetArearesponsName'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyrequestParamHeaders3'),
                        sortable: false,
                        value: 'targetArearesponsDes'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyrequestParamHeaders4'),
                        sortable: false,
                        value: 'targetArearesponsType'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyrequestParamHeaders5'),
                        sortable: false,
                        value: 'targetArearesponsRemark'
                    },
                ];
                return list;
            },
            targetArearesponseParamList() {
                const list = [
                    {
                        targetArearesponsNum: '1',
                        targetArearesponsName: 'status',
                        targetArearesponsDes: '',
                        targetArearesponsType: '',
                        targetArearesponsRemark: ''
                    },
                    {
                        targetArearesponsNum: '2',
                        targetArearesponsName: 'message',
                        targetArearesponsDes: '',
                        targetArearesponsType: '',
                        targetArearesponsRemark: ''
                    },
                    {
                        targetArearesponsNum: '3',
                        targetArearesponsName: 'data',
                        targetArearesponsDes: '',
                        targetArearesponsType: '',
                        targetArearesponsRemark: ''
                    },
                    {
                        targetArearesponsNum: '3.1',
                        targetArearesponsName: 'areaSceneSum',
                        targetArearesponsDes: this.$vuetify.lang.t('$vuetify.API.targetArearesponseParamList31'),
                        targetArearesponsType: 'long',
                        targetArearesponsRemark: ''
                    },
                    {
                        targetArearesponsNum: '3.2',
                        targetArearesponsName: 'areaShootAreaSum',
                        targetArearesponsDes: this.$vuetify.lang.t('$vuetify.API.targetArearesponseParamList32'),
                        targetArearesponsType: 'numeric',
                        targetArearesponsRemark: ''
                    },
                    {
                        targetArearesponsNum: '3.3',
                        targetArearesponsName: 'areaCoverAreaSum',
                        targetArearesponsDes: this.$vuetify.lang.t('$vuetify.API.targetArearesponseParamList33'),
                        targetArearesponsType: 'numeric',
                        targetArearesponsRemark: ''
                    },
                    {
                        targetArearesponsNum: '3.4',
                        targetArearesponsName: 'productSceneSum',
                        targetArearesponsDes: this.$vuetify.lang.t('$vuetify.API.targetArearesponseParamList34'),
                        targetArearesponsType: 'long',
                        targetArearesponsRemark: ''
                    },
                    {
                        targetArearesponsNum: '3.5',
                        targetArearesponsName: 'productShootAreaSum',
                        targetArearesponsDes: this.$vuetify.lang.t('$vuetify.API.targetArearesponseParamList35'),
                        targetArearesponsType: 'numeric',
                        targetArearesponsRemark: ''
                    },
                    {
                        targetArearesponsNum: '3.6',
                        targetArearesponsName: 'productCoverAreaSum',
                        targetArearesponsDes: this.$vuetify.lang.t('$vuetify.API.targetArearesponseParamList36'),
                        targetArearesponsType: 'numeric',
                        targetArearesponsRemark: ''
                    },
                    {
                        targetArearesponsNum: '3.7',
                        targetArearesponsName: 'areaCoverGeo',
                        targetArearesponsDes: this.$vuetify.lang.t('$vuetify.API.targetArearesponseParamList37'),
                        targetArearesponsType: 'string',
                        targetArearesponsRemark: ''
                    },
                    {
                        targetArearesponsNum: '3.8',
                        targetArearesponsName: 'areaCoverPercent',
                        targetArearesponsDes: this.$vuetify.lang.t('$vuetify.API.targetArearesponseParamList38'),
                        targetArearesponsType: 'numeric',
                        targetArearesponsRemark: ''
                    },

                ];
                return list;
            },
            ArchiverequestParamHeaders() {
                //存档数据信息统计接口
                const list = [
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.productInforequestParamHeaders1'),
                        sortable: false,
                        value: 'ArchiveparamName'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.productInforequestParamHeaders2'),
                        sortable: false,
                        value: 'ArchiveparamDes'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.productInforequestParamHeaders3'),
                        sortable: false,
                        value: 'ArchiveparamType'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.productInforequestParamHeaders4'),
                        sortable: false,
                        value: 'ArchiveparamBool'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.productInforequestParamHeaders5'),
                        sortable: false,
                        value: 'ArchiveparamRemark'
                    }
                ];
                return list;
            },
            ArchiverequestParamList() {
                const list = [
                    {
                        ArchiveparamName: 'Authorization',
                        ArchiveparamDes: this.$vuetify.lang.t('$vuetify.API.ArchiverequestParamList1'),
                        ArchiveparamType: 'String',
                        ArchiveparamBool: 'TRUE',
                        ArchiveparamRemark: this.$vuetify.lang.t('$vuetify.API.ArchiverequestParamList2')
                    }
                ];
                return list;
            },
            ArchiveresponseParamHeaders() {
                const list = [
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamHeaders1'),
                        sortable: false,
                        value: 'ArchiveresponsNum'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamHeaders2'),
                        sortable: false,
                        value: 'ArchiveresponsName'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamHeaders3'),
                        sortable: false,
                        value: 'ArchiveresponsDes'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamHeaders4'),
                        sortable: false,
                        value: 'ArchiveresponsType'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamHeaders5'),
                        sortable: false,
                        value: 'ArchiveresponsRemark'
                    },
                ];
                return list;
            },
            ArchiveresponseParamList() {
                const list = [
                    {
                        ArchiveresponsNum: '1',
                        ArchiveresponsName: 'status',
                        ArchiveresponsDes: '',
                        ArchiveresponsType: '',
                        ArchiveresponsRemark: ''
                    },
                    {
                        ArchiveresponsNum: '2',
                        ArchiveresponsName: 'message',
                        ArchiveresponsDes: '',
                        ArchiveresponsType: '',
                        ArchiveresponsRemark: ''
                    },
                    {
                        ArchiveresponsNum: '3',
                        ArchiveresponsName: 'data',
                        ArchiveresponsDes: '',
                        ArchiveresponsType: '',
                        ArchiveresponsRemark: ''
                    },
                    {
                        ArchiveresponsNum: '3.1',
                        ArchiveresponsName: 'sceneSum',
                        ArchiveresponsDes: this.$vuetify.lang.t('$vuetify.API.ArchiveresponseParamList31'),
                        ArchiveresponsType: 'long',
                        ArchiveresponsRemark: ''
                    },
                    {
                        ArchiveresponsNum: '3.2',
                        ArchiveresponsName: 'shootAreaSum',
                        ArchiveresponsDes: this.$vuetify.lang.t('$vuetify.API.ArchiveresponseParamList32'),
                        ArchiveresponsType: 'numeric',
                        ArchiveresponsRemark: ''
                    },
                    {
                        ArchiveresponsNum: '3.3',
                        ArchiveresponsName: 'coverAreaSum',
                        ArchiveresponsDes: this.$vuetify.lang.t('$vuetify.API.ArchiveresponseParamList33'),
                        ArchiveresponsType: 'numeric',
                        ArchiveresponsRemark: ''
                    },
                    {
                        ArchiveresponsNum: '3.4',
                        ArchiveresponsName: 'satelliteAmount',
                        ArchiveresponsDes: this.$vuetify.lang.t('$vuetify.API.ArchiveresponseParamList34'),
                        ArchiveresponsType: 'numeric',
                        ArchiveresponsRemark: ''
                    },
                ];
                return list;
            },
            transitrequestParamHeaders() {
                //过境查询接口
                const list = [
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.productInforequestParamHeaders1'),
                        sortable: false,
                        value: 'transitparamName'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.productInforequestParamHeaders2'),
                        sortable: false,
                        value: 'transitparamDes'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.productInforequestParamHeaders3'),
                        sortable: false,
                        value: 'transitparamType'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.productInforequestParamHeaders4'),
                        sortable: false,
                        value: 'transitparamBool'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.productInforequestParamHeaders5'),
                        sortable: false,
                        value: 'transitparamRemark'
                    }
                ];
                return list;
            },
            transitrequestParamList() {
                const list = [
                    {
                        transitparamName: ' longitude',
                        transitparamDes: this.$vuetify.lang.t('$vuetify.API.transitrequestParamList1'),
                        transitparamType: 'BigDecimal',
                        transitparamBool: 'TRUE',
                        transitparamRemark: ''
                    },
                    {
                        transitparamName: ' latitude',
                        transitparamDes: this.$vuetify.lang.t('$vuetify.API.transitrequestParamList2'),
                        transitparamType: 'BigDecimal',
                        transitparamBool: 'TRUE',
                        transitparamRemark: ''
                    },
                    {
                        transitparamName: 'satelliteId ',
                        transitparamDes: this.$vuetify.lang.t('$vuetify.API.transitrequestParamList31'),
                        transitparamType: 'String ',
                        transitparamBool: 'TRUE',
                        transitparamRemark: this.$vuetify.lang.t('$vuetify.API.transitrequestParamList32')
                    },
                    {
                        transitparamName: 'startTime ',
                        transitparamDes: this.$vuetify.lang.t('$vuetify.API.transitrequestParamList4'),
                        transitparamType: 'String ',
                        transitparamBool: 'TRUE',
                        transitparamRemark: ''
                    },
                    {
                        transitparamName: 'endTime ',
                        transitparamDes: this.$vuetify.lang.t('$vuetify.API.transitrequestParamList5'),
                        transitparamType: 'String ',
                        transitparamBool: 'TRUE',
                        transitparamRemark: ''
                    },
                ];
                return list;
            },
            transitresponseParamHeaders() {
                const list = [
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamHeaders1'),
                        sortable: false,
                        value: 'transitresponsNum'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamHeaders2'),
                        sortable: false,
                        value: 'transitresponsName'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamHeaders3'),
                        sortable: false,
                        value: 'transitresponsDes'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamHeaders4'),
                        sortable: false,
                        value: 'transitresponsType'
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamHeaders5'),
                        sortable: false,
                        value: 'transitresponsRemark'
                    },
                ];
                return list;
            },
            transitresponseParamList() {
                const list = [
                    {
                        transitresponsNum: '1',
                        transitresponsName: 'status',
                        transitresponsDes: '',
                        transitresponsType: '',
                        transitresponsRemark: ''
                    },
                    {
                        transitresponsNum: '2',
                        transitresponsName: 'message',
                        transitresponsDes: '',
                        transitresponsType: '',
                        transitresponsRemark: ''
                    },
                    {
                        transitresponsNum: '3',
                        transitresponsName: 'data',
                        transitresponsDes: '',
                        transitresponsType: '',
                        transitresponsRemark: ''
                    },
                    {
                        transitresponsNum: '3.1',
                        transitresponsName: 'sideAngle',
                        transitresponsDes: this.$vuetify.lang.t('$vuetify.API.transitresponseParamList31'),
                        transitresponsType: 'numeric',
                        transitresponsRemark: ''
                    },
                    {
                        transitresponsNum: '3.2',
                        transitresponsName: 'startAvailableTime',
                        transitresponsDes: this.$vuetify.lang.t('$vuetify.API.transitresponseParamList32'),
                        transitresponsType: 'String',
                        transitresponsRemark: ''
                    },
                    {
                        transitresponsNum: '3.3',
                        transitresponsName: 'endAvailableTime',
                        transitresponsDes: this.$vuetify.lang.t('$vuetify.API.transitresponseParamList33'),
                        transitresponsType: 'String',
                        transitresponsRemark: ''
                    },
                    {
                        transitresponsNum: '3.4',
                        transitresponsName: 'solarEA',
                        transitresponsDes: this.$vuetify.lang.t('$vuetify.API.transitresponseParamList34'),
                        transitresponsType: 'numeric',
                        transitresponsRemark: ''
                    },
                ];
                return list;
            },
            //编程摄影
            ProgrammingrequestParamHeaders() {
                const list =
                    [
                        {text: this.$vuetify.lang.t('$vuetify.API.KeyrequestParamHeaders1'), sortable: false, value: 'ProgrammingparamName'},
                        {text: this.$vuetify.lang.t('$vuetify.API.KeyrequestParamHeaders2'), sortable: false, value: 'ProgrammingparamDes'},
                        {text: this.$vuetify.lang.t('$vuetify.API.KeyrequestParamHeaders3'), sortable: false, value: 'ProgrammingparamType'},
                        {text: this.$vuetify.lang.t('$vuetify.API.KeyrequestParamHeaders4'), sortable: false, value: 'ProgrammingparamBool'},
                        {text: this.$vuetify.lang.t('$vuetify.API.KeyrequestParamHeaders5'), sortable: false, value: 'ProgrammingparamRemark'}
                    ];
                return list;
            },
            ProgrammingrequestParamList(){
                const list =                [
                    {
                        ProgrammingparamName: 'clientId',
                        ProgrammingparamDes: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList1'),
                        ProgrammingparamType: 'String ',
                        ProgrammingparamBool: 'TRUE',
                        ProgrammingparamRemark: ''
                    },
                    {
                        ProgrammingparamName: 'clientName',
                        ProgrammingparamDes: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList2'),
                        ProgrammingparamType: 'String ',
                        ProgrammingparamBool: 'TRUE',
                        ProgrammingparamRemark: ''
                    },
                    {
                        ProgrammingparamName: 'cloudPercent',
                        ProgrammingparamDes: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList3'),
                        ProgrammingparamType: 'String',
                        ProgrammingparamBool: 'FALSE',
                        ProgrammingparamRemark: ''
                    },
                    {
                        ProgrammingparamName: 'deliveryTime',
                        ProgrammingparamDes: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList41'),
                        ProgrammingparamType: 'int ',
                        ProgrammingparamBool: 'FALSE',
                        ProgrammingparamRemark: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList42')
                    },
                    {
                        ProgrammingparamName: 'geometryRequirement',
                        ProgrammingparamDes: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList51'),
                        ProgrammingparamType: 'int ',
                        ProgrammingparamBool: 'FALSE',
                        ProgrammingparamRemark: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList52')
                    },
                    {
                        ProgrammingparamName: 'imageDuration',
                        ProgrammingparamDes: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList5'),
                        ProgrammingparamType: 'String ',
                        ProgrammingparamBool: 'FALSE',
                        ProgrammingparamRemark: ''
                    },
                    {
                        ProgrammingparamName: 'imageGeometry',
                        ProgrammingparamDes: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList6'),
                        ProgrammingparamType: 'String ',
                        ProgrammingparamBool: 'TRUE ',
                        ProgrammingparamRemark: 'geojson '
                    },
                    {
                        ProgrammingparamName: 'imageMode',
                        ProgrammingparamDes: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList71'),
                        ProgrammingparamType: 'int ',
                        ProgrammingparamBool: 'TRUE ',
                        ProgrammingparamRemark: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList72')
                    },
                    {
                        ProgrammingparamName: 'imagingEndTime',
                        ProgrammingparamDes: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList8'),
                        ProgrammingparamType: 'Date ',
                        ProgrammingparamBool: 'FALSE',
                        ProgrammingparamRemark: ''
                    },
                    {
                        ProgrammingparamName: 'imagingFrequencyRequest',
                        ProgrammingparamDes: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList91'),
                        ProgrammingparamType: 'int ',
                        ProgrammingparamBool: 'TRUE',
                        ProgrammingparamRemark: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList92')
                    },
                    {
                        ProgrammingparamName: 'imagingInternal',
                        ProgrammingparamDes: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList10'),
                        ProgrammingparamType: 'String ',
                        ProgrammingparamBool: 'TRUE',
                        ProgrammingparamRemark: ''
                    },
                    {
                        ProgrammingparamName: 'imagingSatellite',
                        ProgrammingparamDes: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList11'),
                        ProgrammingparamType: 'String ',
                        ProgrammingparamBool: 'FALSE',
                        ProgrammingparamRemark: ''
                    },
                    {
                        ProgrammingparamName: 'imagingStartTime',
                        ProgrammingparamDes: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList12'),
                        ProgrammingparamType: 'Date',
                        ProgrammingparamBool: 'FALSE',
                        ProgrammingparamRemark: ''
                    },
                    {
                        ProgrammingparamName: 'isMultiGrid',
                        ProgrammingparamDes: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList131'),
                        ProgrammingparamType: 'int ',
                        ProgrammingparamBool: 'FALSE',
                        ProgrammingparamRemark: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList132')
                    },
                    {
                        ProgrammingparamName: 'isSensitive',
                        ProgrammingparamDes: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList141'),
                        ProgrammingparamType: 'int ',
                        ProgrammingparamBool: 'FALSE',
                        ProgrammingparamRemark: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList142')
                    },
                    {
                        ProgrammingparamName: 'priority',
                        ProgrammingparamDes: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList15'),
                        ProgrammingparamType: 'int ',
                        ProgrammingparamBool: 'FALSE',
                        ProgrammingparamRemark: '1，2，3，4'
                    },
                    {
                        ProgrammingparamName: 'productType',
                        ProgrammingparamDes: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList16'),
                        ProgrammingparamType: 'String',
                        ProgrammingparamBool: 'TRUE',
                        ProgrammingparamRemark: ''
                    },
                    {
                        ProgrammingparamName: 'radiationRequirement',
                        ProgrammingparamDes: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList171'),
                        ProgrammingparamType: 'int ',
                        ProgrammingparamBool: 'FALSE',
                        ProgrammingparamRemark: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList172')
                    },
                    {
                        ProgrammingparamName: 'requestName',
                        ProgrammingparamDes: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList18'),
                        ProgrammingparamType: 'String ',
                        ProgrammingparamBool: 'FALSE',
                        ProgrammingparamRemark: ''
                    },
                    {
                        ProgrammingparamName: 'requestType',
                        ProgrammingparamDes: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList191'),
                        ProgrammingparamType: 'int ',
                        ProgrammingparamBool: 'TRUE',
                        ProgrammingparamRemark: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList192')
                    },
                    {
                        ProgrammingparamName: 'requirementremark',
                        ProgrammingparamDes: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList20'),
                        ProgrammingparamType: 'String ',
                        ProgrammingparamBool: 'FALSE',
                        ProgrammingparamRemark: ''
                    },
                    {
                        ProgrammingparamName: 'resolution',
                        ProgrammingparamDes: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList21'),
                        ProgrammingparamType: 'BigDecimal ',
                        ProgrammingparamBool: 'FALSE',
                        ProgrammingparamRemark: ''
                    },
                    {
                        ProgrammingparamName: 'satelliteImagingTimes',
                        ProgrammingparamDes: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList22'),
                        ProgrammingparamType: 'String ',
                        ProgrammingparamBool: 'FALSE',
                        ProgrammingparamRemark: ''
                    },
                    {
                        ProgrammingparamName: 'rollSatelliteAngle',
                        ProgrammingparamDes: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList23'),
                        ProgrammingparamType: 'String ',
                        ProgrammingparamBool: 'FALSE',
                        ProgrammingparamRemark: ''
                    },
                    {
                        ProgrammingparamName: 'spectralRequirement',
                        ProgrammingparamDes: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList241'),
                        ProgrammingparamType: 'int',
                        ProgrammingparamBool: 'FALSE',
                        ProgrammingparamRemark: this.$vuetify.lang.t('$vuetify.API.ProgrammingrequestParamList242')
                    },
                ];
                return list;
            },
            ProgrammingresponseParamHeaders(){
                const  list= [
                    {text: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamHeaders1'), sortable: false, value: 'ProgrammingresponsNum'},
                    {text: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamHeaders2'), sortable: false, value: 'ProgrammingresponsName'},
                    {text: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamHeaders3'), sortable: false, value: 'ProgrammingresponsDes'},
                    {text: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamHeaders4'), sortable: false, value: 'ProgrammingresponsType'},
                    {text: this.$vuetify.lang.t('$vuetify.API.KeyresponseParamHeaders5'), sortable: false, value: 'ProgrammingresponsRemark'},
                ];
                return list;
            },
            ProgrammingsponseParamList(){
                const list = [
                    {
                        ProgrammingresponsNum: '1',
                        ProgrammingresponsName: 'status',
                        ProgrammingresponsDes: '',
                        ProgrammingresponsType: '',
                        ProgrammingresponsRemark: ''
                    },
                    {
                        ProgrammingresponsNum: '2',
                        ProgrammingresponsName: 'message',
                        ProgrammingresponsDes: '',
                        ProgrammingresponsType: '',
                        ProgrammingresponsRemark: ''
                    },
                    {
                        ProgrammingresponsNum: '3',
                        ProgrammingresponsName: 'data',
                        ProgrammingresponsDes: '',
                        ProgrammingresponsType: '',
                        ProgrammingresponsRemark: ''
                    },
                    {
                        ProgrammingresponsNum: '3.1',
                        ProgrammingresponsName: 'requirementId',
                        ProgrammingresponsDes: this.$vuetify.lang.t('$vuetify.API.ProgrammingsponseParamList4'),
                        ProgrammingresponsType: 'String',
                        ProgrammingresponsRemark: ''
                    },
                ];
                return list;
            },
        },
        mounted() {
            this.loadData()
        },
    }
</script>

<style scoped>
    #sidebar {
        position: absolute;
        left: 0px;
        top: 0px;
        width: 190px;
        height: 100%;
        min-width: 250px;
        z-index: 20;
        font-family: "Microsoft YaHei", 微软雅黑, sans-serif;
        background: rgb(255, 255, 255);
        overflow: hidden;
    }
</style>
